import { render } from "./SettingsTabs.vue?vue&type=template&id=648f0538"
import script from "./SettingsTabs.vue?vue&type=script&lang=js"
export * from "./SettingsTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__